import React from "react";
import Grid from "@mui/material/Grid";
import Title from "/app/components/LandingPage/Title";
import useStyles from "/app/components/LandingPage/landingStyle-jss";
import cisoResourcesIcon from "/app/images/features/Ciso.webp";
import cyberkidResourcesIcon from "/app/images/features/cyber-kid.webp";
import digiNagresources from "/app/images/features/dig-naagriks.webp";
import ideationresources from "/app/images/features/ideation.webp";
import "./resources.css";

const ResourcesMain = (props) => {
  const { slideMode } = props;
  const { classes, cx } = useStyles();
  return (
    <div>
      <div className="py-5 section-resources">
        <div className={slideMode ? classes.fullWidth : classes.container}>
          {/* <Title
            title="Resources"
            // desc="Integrated all your services at one platform"
            align="center"
          /> */}
          <Grid container spacing={2}>
            <Grid item md={1}></Grid>
            <Grid item md={3} xs={12}>
              <div className="resourceIconImages">
                <img src={digiNagresources} />
              </div>
            </Grid>
            <Grid item md={3} xs={12}>
              <div className="resourceIconImages">
                <img src={cisoResourcesIcon} />
              </div>
            </Grid>
            {/* <Grid item md={3} xs={12}>
              <div className="resourceIconImages">
                <img src={cyberkidResourcesIcon} />
              </div>
            </Grid> */}
            <Grid item md={3} xs={12}>
              <div className="resourceIconImages">
                <img src={ideationresources} />
              </div>
            </Grid>
            <Grid item md={1}></Grid>
          </Grid>
        </div>
      </div>
    </div>
  );
};

export default ResourcesMain;
